export default __webpack_public_path__ + "static/media/IMG_0081.664201b7.jpeg";